import useHyreadSearch from '../../Hooks/useHyreadSearch.jsx';
import useUdnSearch from '../../Hooks/useUdnSearch.jsx';
import usePublicInfo from '../../Hooks/usePublicInfoSearch.jsx';
import useCloudSearch from '../../Hooks/useCloudSearch.jsx';
import useIreadSearch from '../../Hooks/useIreadSearch.jsx';

import cn from 'classnames';
import { useOutletContext } from 'react-router-dom';
import { Loader } from 'semantic-ui-react';
import './SearchResult.scss';
import { useState } from 'react';
import { DISPLAY_RESULT_AMOUNT } from '../../Constant/constant.js';
import { limitBookNameLength } from './Utils.jsx';
import { useLocation } from 'react-router-dom';

const Result = ({ platform }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const searchBookName = params.get('book');
  const {
    cities,
    setHyreadLoaded,
    setUdnLoaded,
    setPublicLoaded,
    setCloudLoaded,
    setIreadLoaded,
    noCityWarning,
  } = useOutletContext();

  let results = [];
  let loading = false;
  let error = null;

  if (!noCityWarning) {
    if (platform === 'Hyread') {
      const hyreadResult = useHyreadSearch(cities, searchBookName);
      ({ results = [], loading, error } = hyreadResult);
      setHyreadLoaded(!loading);
    } else if (platform === 'UDN') {
      const udnResult = useUdnSearch(cities, searchBookName);
      ({ results = [], loading, error } = udnResult);
      setUdnLoaded(!loading);
    } else if (platform === '國立公共資訊圖書館') {
      const publicInfoResult = usePublicInfo(searchBookName);
      ({ results = [], loading, error } = publicInfoResult);
      setPublicLoaded(!loading);
    } else if (platform === '台灣雲端書庫') {
      const cloudResult = useCloudSearch(cities, searchBookName);
      ({ results = [], loading, error } = cloudResult);
      setCloudLoaded(!loading);
    } else if (platform === '華藝電子書') {
      const iReadResult = useIreadSearch(searchBookName);
      ({ results = [], loading, error } = iReadResult);
      setIreadLoaded(!loading);
    }
  }

  const [activeTitle, setActiveTitle] = useState([
    true,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ]);
  const displayMoreResultsHint = results.length >= DISPLAY_RESULT_AMOUNT;

  const handleClick = (index) => {
    setActiveTitle((prev) => {
      let updated = [...prev];
      updated = updated.map((_, i) => {
        if (i === index) {
          return !prev[index];
        } else {
          return false;
        }
      });
      return updated;
    });
  };

  return !noCityWarning ? (
    <div className="content-block">
      <div className="items">
        <div className="items-head">
          <p>{platform.toUpperCase()}</p>
          <hr />
        </div>
        <div className="items-body">
          <div className="items-body-content">
            {loading ? (
              <div className="search-result-loading">
                <Loader active inline />
              </div>
            ) : error ? (
              <div style={{ margin: '5px 0 10px 20px', color: 'red' }}>
                出現錯誤，請重新整理或稍後再試
              </div>
            ) : results.length === 0 ? (
              <div style={{ margin: '5px 0 10px 20px' }}>沒有找到</div>
            ) : (
              <div className="items-list">
                <div className="ui accordion">
                  {results.map((book, index) => {
                    return (
                      <>
                        <div
                          className={cn('title', {
                            active:
                              activeTitle[index] &&
                              platform !== '國立公共資訊圖書館',
                          })}
                          onClick={() => handleClick(index)}
                        >
                          <i className="dropdown icon"></i>
                          {platform !== '國立公共資訊圖書館' ? (
                            limitBookNameLength(book.title)
                          ) : (
                            <a href={book.link} target="_blank">
                              {limitBookNameLength(book.title)}
                            </a>
                          )}
                        </div>
                        <div
                          className={cn('content', {
                            active:
                              activeTitle[index] &&
                              platform !== '國立公共資訊圖書館',
                          })}
                        >
                          <div class="ui bulleted list">
                            {book.libraries.map((lib) => {
                              return (
                                <a class="item" href={lib.link} target="_blank">
                                  {lib.name}
                                </a>
                              );
                            })}
                          </div>
                        </div>
                      </>
                    );
                  })}
                </div>
                {displayMoreResultsHint ? (
                  <div
                    style={{ margin: '10px 0 0 5px' }}
                  >{`前往 ${platform.toUpperCase()} 看更多搜尋結果`}</div>
                ) : null}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default Result;
